export const tipoCertificado = {
    PDF: 1,
    EMAIL: 2
}